import { Link } from 'react-router-dom';
import { BUSINESS, telHref } from '../config/business';
import prototype from '../config/prototype.json';
import { StudioCredit } from './Prototype';
import styles from './Footer.module.css';

const LINKS = [
  { to: '/about', label: 'About' },
  { to: '/gallery', label: 'Gallery' },
  { to: '/contact', label: 'Contact' },
];

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.brandCol}>
          <p className={styles.brand}>Herculean Homes</p>
          <p className={styles.tagline}>Custom built. Built to last.</p>
          <p className={styles.trustLine}>Licensed &amp; Insured General Contractor</p>
          {(BUSINESS.phone || BUSINESS.email || BUSINESS.serviceArea) && (
            <address className={styles.contact}>
              {BUSINESS.phone && <a href={telHref(BUSINESS.phone)}>{BUSINESS.phone}</a>}
              {BUSINESS.email && (
                <a href={`mailto:${BUSINESS.email}`}>{BUSINESS.email}</a>
              )}
              {BUSINESS.serviceArea && <span>{BUSINESS.serviceArea}</span>}
            </address>
          )}
        </div>

        <nav className={styles.links} aria-label="Footer">
          {LINKS.map((link) => (
            <Link key={link.to} to={link.to} className={styles.link}>
              {link.label}
            </Link>
          ))}
        </nav>

        <p className={styles.copyright}>
          {/* TEMPORARY: prototype mode credits the studio, not the company, because the
              company did not commission this prototype. */}
          &copy; {year} {prototype.enabled ? prototype.builtBy : 'Herculean Homes'}
          <span className={styles.credit}>
            {' '}
            &middot; <StudioCredit />
          </span>
        </p>
      </div>
    </footer>
  );
}
